export const filterSchemaFieldsByVisibility = ({
  schemaFields,
  isEdit = false,
}) => {
  const schemaList = Array.isArray(schemaFields) ? schemaFields : []

  const isSchemaFieldVisible = ({ fieldItem, isEdit }) => {
    if (!fieldItem) return false
    if (isEdit && fieldItem.hideWhenEditing) return false
    if (fieldItem.hidden) return false
    return true
  }

  return schemaList.filter((fieldItem) =>
    isSchemaFieldVisible({ fieldItem, isEdit })
  )
}
